import { inject } from '@vercel/analytics';
import { isFinanceDocument } from '../lib/financePrivacy';

// Initialize Vercel Analytics
export function initAnalytics() {
  if (isFinanceDocument) return;
  try {
    inject({
      mode: import.meta.env.PROD ? 'production' : 'development',
      debug: !import.meta.env.PROD,
    });
    if (import.meta.env.DEV) {
      console.log('[Analytics] Vercel Analytics initialized');
    }
  } catch (error) {
    console.warn('[Analytics] Failed to initialize Vercel Analytics:', error);
  }
}
